/** Best-effort label for a background-generating chat, in priority order: the
 * known chat title, else the prompt preview captured at submit (fresh chats
 * have no title yet), else a generic fallback. Whitespace-only inputs count as
 * absent. */
export function resolveRunningChatLabel(input: {
  title: string | undefined;
  preview: string | undefined;
  generic: string;
}): string {
  const title = input.title?.trim();
  if (title) return title;
  const preview = input.preview?.trim();
  if (preview) return preview;
  return input.generic;
}
